import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Avatar,
  Grid,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Chip,
  Skeleton,
  TextField,
  Button,
  Card,
} from "@mui/material";
import {
  Edit as EditIcon,
  Info as InfoIcon,
  ChevronRight as ChevronRightIcon,
  PersonSearch,
  PersonSearchOutlined,
  LockOutlined,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import UserEditAvatar from "./UserEditAvatar";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import UserFaqScreen from "./UserFaqScreen";

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(3),
  padding: theme.spacing(3),
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

const StatBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(1),
}));

const BadgeWrapper = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(1),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 70,
  height: 70,
  marginBottom: theme.spacing(1),
}));

const MenuPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(3),
  background: theme.palette.grey[50],
  overflow: "hidden",
  marginTop: "20px",
}));

const ProfileComponent = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(true);
  const [isLoadingReset, setIsLoadingReset] = useState(false);
  const [isUpdatingAvatar, setIsUpdatingAvatar] = useState(false);
  const [screen, setScreen] = useState("profile");
  const [openEditName, setOpenEditName] = useState(false);
  const [userData, setUserData] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    currentEmployeeRank: "0",
    currentEmployeeScore: "0",
    avatar: "1",
    courses: {
      awareness: { total: 0, completed: 0 },
      compliance: { total: 0, completed: 0 },
      nano: { total: 0, completed: 0 },
    },
  });

  useEffect(() => {
    Promise.all([getCourses(), fetchLeaderBoard()]).then(() =>
      setIsLoading(false)
    );
  }, []);
  const fetchLeaderBoard = async () => {
    const token = localStorage.getItem("token") || "";
    const company = localStorage.getItem("company");
    const userId = localStorage.getItem("userId");
    const avatar = localStorage.getItem("avatar");
    try {
      const response = await fetch(
        `https://beiguru.co.in/api/leaderboard/${company}/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        setUserData((prev) => ({
          ...prev,
          currentEmployeeRank: result.currentEmployee.rank?.toString() || "0",
          currentEmployeeScore: result.currentEmployee.score.toString(),
          avatar: avatar,
        }));
      }
    } catch (error) {
      console.error("Error fetching leaderboard:", error);
    }
  };

  const getCourses = async () => {
    try {
      const token = localStorage.getItem("token") || "";
      const userId = localStorage.getItem("userId") || "";
      const company = localStorage.getItem("company") || "";

      setUserData((prev) => ({
        ...prev,
        companyName: localStorage.getItem("companyName") || "",
        firstName: localStorage.getItem("firstName") || "",
        lastName: localStorage.getItem("lastName") || "",
        email: localStorage.getItem("email") || "",
        phoneNumber: localStorage.getItem("phoneNumber") || "",
      }));

      const [progressResponse, coursesResponse] = await Promise.all([
        fetch(`https://beiguru.co.in/api/progress/${userId}`, {
          headers: { Authorization: token },
        }),
        fetch(`https://beiguru.co.in/admin/courses-company/${company}`, {
          headers: { Authorization: token },
        }),
      ]);

      const [progressData, coursesData] = await Promise.all([
        progressResponse.json(),
        coursesResponse.json(),
      ]);
      calculateCourseStats(coursesData, progressData);
    } catch (error) {
      console.error("Error while fetching courses:", error);
    }
  };

  const calculateCourseStats = (coursesJson, parsedData) => {
    const completedCourses = coursesJson.reduce(
      (acc, course) => {
        const completed = parsedData.some(
          (progress) => progress.course === course._id && progress.isFinal
        );
        if (completed) acc.awareness++;
        return acc;
      },
      { awareness: 0, compliance: 0, nano: 0 }
    );

    setUserData((prev) => ({
      ...prev,
      courses: {
        awareness: {
          total: coursesJson.length,
          completed: completedCourses.awareness,
        },
        compliance: { total: 0, completed: completedCourses.compliance },
        nano: { total: 0, completed: completedCourses.nano },
      },
    }));
  };

  // Debugging logs to check state
  console.log("forgotPassword state:", forgotPassword);

  // Toggle forgotPassword view
  const handleForgotPasswordClick = () => {
    console.log("Reset Password clicked!");
    setForgotPassword(true); // Toggling the state
  };

  const handleEmailChange = (event) => {
    const value = event.target.value;
    setEmail(value);
    setEmailValid(value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i));
  };


  const handleNameUpdate = async () => {
    const token = localStorage.getItem("token") || "";
    const userId = localStorage.getItem("userId") || "";

    try {
      const response = await fetch(`https://beiguru.co.in/api/employees/${userId}/firstName`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          firstName: userData.firstName,
        }),
      });

      if (response.ok) {
        alert("Name updated successfully!");
        setOpenEditName(false); // Close the popup
      } else {
        alert("Failed to update name.");
      }
    } catch (error) {
      console.error("Error updating name:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  //   const handleForgotPasswordSubmit = (event) => {
  //     event.preventDefault();
  //     if (!email || !emailValid) {
  //       alert("Please enter a valid email!");
  //       return;
  //     }

  //     setIsLoadingReset(true);
  //     const myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");

  //     const raw = JSON.stringify({ email });

  //     const requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     fetch("https://beiguru.co.in/admin/forgot-password", requestOptions)
  //       .then((response) => {
  //         setIsLoadingReset(false);
  //         if (response.ok) {
  //           alert(
  //             "A new temporary password has been sent to your email. Please check your email."
  //           );
  //           setForgotPassword(false); // After successful reset, go back to profile.
  //         } else {
  //           alert("This Email ID does not exist.");
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //         setIsLoadingReset(false);
  //       });
  //   };

  const handleForgotPasswordSubmit = async (event) => {
    event.preventDefault();

    if (!email || !emailValid) {
      alert("Please enter a valid email!");
      return;
    }

    setIsLoadingReset(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({ email });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://beiguru.co.in/admin/forgot-password",
        requestOptions
      );

      const responseBody = await response.json(); // Get the response body
      console.log("API Response:", responseBody);

      setIsLoadingReset(false);

      if (response.ok) {
        alert("A new temporary password has been sent to your email.");
        setForgotPassword(false);
      } else {
        alert(
          "This Email ID does not exist. Server Response: " +
          responseBody.message
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
      alert("Something went wrong. Please try again later.");
      setIsLoadingReset(false);
    }
  };

  const handleAvatarChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const token = localStorage.getItem("token") || "";
    const userId = localStorage.getItem("userId") || "";

    const formData = new FormData();
    formData.append("avatar", file);

    setIsUpdatingAvatar(true);

    try {

      const response = await fetch(
        `https://beiguru.co.in/api/employees/${userId}/avatar`,
        {
          method: "POST",
          headers: { Authorization: token },
          body: formData,
        }
      );

      if (response.ok) {
        const data = await response.json();
        setUserData((prev) => ({
          ...prev,
          avatar: data.avatar, // Assume API response returns the new avatar URL or ID
        }));
        localStorage.setItem("avatar", data.avatar);
        alert("Avatar updated successfully!");
      } else {
        alert(response.status);
      }
    } catch (error) {
      console.error("Error updating avatar:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsUpdatingAvatar(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {isLoading ? (
        <Box sx={{ width: "100%" }}>
          <Skeleton
            variant="rectangular"
            height={200}
            sx={{ borderRadius: 4, mb: 2 }}
          />
          <Skeleton
            variant="rectangular"
            height={150}
            sx={{ borderRadius: 4 }}
          />
        </Box>
      ) : (
        <>
          {forgotPassword ? (
            <Card
              style={{
                width: "100%",
                height: "100%",
                padding: "20px",
              }}
            >
              <form onSubmit={handleForgotPasswordSubmit}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Reset Password
                </Typography>
                <TextField
                  label="Email Address"
                  type="email"
                  value={email}
                  onChange={handleEmailChange}
                  fullWidth
                  error={!emailValid}
                  helperText={
                    !emailValid && "Please enter a valid email address"
                  }
                  sx={{ marginBottom: 2 }}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    height: 50,
                    borderRadius: "20px",
                  }}
                  disabled={isLoadingReset}
                >
                  {isLoadingReset ? "Loading..." : "Reset Password"}
                </Button>
              </form>
            </Card>
          ) : (
            <>
              <Box sx={{ py: 4 }}>
                <Card
                  sx={{
                    maxWidth: 600,
                    mx: "auto",
                    mt: 4,
                    borderRadius: 3,
                    boxShadow: 4,
                    overflow: "hidden",
                    p: 3,
                    background:
                      "linear-gradient(120deg,rgb(127, 168, 250),rgb(88, 58, 255))",
                    color: "white",
                  }}
                >
                  {/* Profile Header */}
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexDirection="column"
                  >
                    <Box position="relative" mb={1}>
                      {/* The Avatar is clickable */}
                      <Avatar
                        src={userData.avatar.includes('uploads') ? `https://beiguru.co.in/${userData.avatar}` : require(`../assets/a${userData.avatar}.png`)} // Replace with dynamic URL logic if needed
                        sx={{
                          width: 100,
                          height: 100,
                          border: "4px solid #fff",
                          boxShadow: 2,
                          cursor: "pointer", // Makes the Avatar clickable
                        }}
                        onClick={() => document.getElementById("avatar-upload").click()} // Triggers the file input
                      />
                      <input
                        type="file"
                        accept="image/*"
                        style={{
                          display: "none", // Hide the input element
                        }}
                        id="avatar-upload"
                        onChange={handleAvatarChange} // Function to handle file selection
                      />
                      <IconButton
                        size="small"
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          bgcolor: "white",
                          boxShadow: 1,
                          "&:hover": { bgcolor: "#f0f0f0" },
                        }}
                        component="span"
                        onClick={() => document.getElementById("avatar-upload").click()} // Triggers the file input
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center">
                      <Typography variant="h5" fontWeight="bold" color="white">
                        {userData.firstName} ({userData.lastName})
                      </Typography>
                      <IconButton
                        size="small"
                        sx={{ color: "white", ml: 1 }}
                        onClick={() => setOpenEditName(true)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Box>

                    <Typography variant="body2" color="white">
                      {userData.email}
                    </Typography>
                  </Box>

                  {/* Profile Stats */}
                  <Grid
                    container
                    spacing={2}
                    justifyContent="center"
                    sx={{ mt: 3 }}
                  >
                    <Grid item xs={4}>
                      <Box textAlign="center">
                        <Typography variant="overline" color="white">
                          Rank
                        </Typography>
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          color="white"
                        >
                          {userData.currentEmployeeRank}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box textAlign="center">
                        <Typography variant="overline" color="white">
                          Score
                        </Typography>
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          color="white"
                        >
                          {userData.currentEmployeeScore}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box textAlign="center">
                        <Typography variant="overline" color="white">
                          Completed
                        </Typography>
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          color="white"
                        >
                          {Object.values(userData.courses).reduce(
                            (sum, course) => sum + course.completed,
                            0
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  <Divider
                    sx={{ my: 3, bgcolor: "rgba(255, 255, 255, 0.4)" }}
                  />

                  {/* Profile Actions */}
                  <List disablePadding>
                    <ListItem button>
                      <ListItemIcon>
                        <InfoIcon sx={{ color: "white" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="Frequently Asked Questions"
                        sx={{ color: "white" }}
                      />
                    </ListItem>
                    <Divider sx={{ bgcolor: "rgba(255, 255, 255, 0.4)" }} />
                    <ListItem button onClick={handleForgotPasswordClick}>
                      <ListItemIcon>
                        <PersonSearchOutlined sx={{ color: "white" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="Reset Password"
                        sx={{ color: "white" }}
                      />
                    </ListItem>
                    <Divider sx={{ bgcolor: "rgba(255, 255, 255, 0.4)" }} />
                    {/* <ListItem button>
          <ListItemIcon>
            <LockOutlined sx={{ color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Change Password" sx={{ color: "white" }} />
        </ListItem> */}
                  </List>
                </Card>

                {/* Reset Password Form */}
                {forgotPassword && (
                  <form onSubmit={handleForgotPasswordSubmit}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      Reset Password
                    </Typography>
                    <TextField
                      label="Email Address"
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      fullWidth
                      error={!emailValid}
                      helperText={
                        !emailValid && "Please enter a valid email address"
                      }
                      sx={{ marginBottom: 2 }}
                    />
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{
                        height: 50,
                        borderRadius: "20px",
                      }}
                      disabled={isLoadingReset}
                    >
                      {isLoadingReset ? "Loading..." : "Reset Password"}
                    </Button>
                  </form>
                )}
              </Box>
            </>
          )}
        </>
      )}
      <Dialog open={openEditName} onClose={() => setOpenEditName(false)} fullWidth maxWidth="sm">
        <DialogTitle>Edit Name</DialogTitle>
        <DialogContent>
          <TextField
            label="Full Name"
            value={userData.firstName}
            onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
            fullWidth
            sx={{ marginBottom: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditName(false)} color="secondary">Cancel</Button>
          <Button onClick={handleNameUpdate} variant="contained" color="primary">Save</Button>
        </DialogActions>
      </Dialog>

    </Container>
  );
};

export default ProfileComponent;
